import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useCommunity } from "@/context/CommunityContext";

export function AdminDashboard() {
  const { community } = useCommunity();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/admin/dashboard", { params: community ? { community_id: community.id } : {} })
      .then(({ data }) => setStats(data))
      .catch((e) => setError(errMsg(e)));
  }, [community]);

  const tiles = [
    ["Gemeinden", stats?.communities],
    ["Aktive Wege", stats?.walks],
    ["Aktive Challenges", stats?.challenges],
    ["Aktive Spiele", stats?.games],
    ["Benutzer", stats?.users],
    ["Offene Bestätigungen", stats?.pending_confirmations],
    ["Ideenvorschläge (neu)", stats?.ideas],
    ["Meldungen (neu)", stats?.reports],
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl">Dashboard</h1>
      <p className="text-sm text-[var(--ink-soft)]">{community?.name || "Alle Gemeinden"}</p>
      {error ? <p className="mt-4 text-sm text-red-700">{error}</p> : null}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {tiles.map(([label, value]) => (
          <div key={label} className="rounded-2xl border bg-white p-5" data-testid={`tile-${label.replace(/\s+/g, "-").toLowerCase()}`}>
            <p className="eyebrow">{label}</p>
            <p className="mt-2 text-4xl">{value ?? "–"}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AdminReporting() {
  const { community } = useCommunity();
  const [data, setData] = useState(null);
  const [excludeTest, setExcludeTest] = useState(true);

  useEffect(() => {
    api
      .get("/admin/reporting", { params: { ...(community ? { community_id: community.id } : {}), exclude_test: excludeTest } })
      .then(({ data: payload }) => setData(payload))
      .catch(() => setData(null));
  }, [community, excludeTest]);

  const rows = [
    ["Benutzer", data?.users],
    ["Wege gestartet", data?.walks_started],
    ["Wege abgeschlossen", data?.walks_completed],
    ["Challenge-Teilnahmen", data?.challenge_entries],
    ["bestätigte Challenges", data?.challenge_entries_confirmed],
    ["Matches (bestätigt)", data?.matches],
    ["LOSER-Partien", data?.loser_matches],
    ["Liebesbaum-Einträge", data?.love_messages],
    ["Ideenvorschläge", data?.ideas],
    ["Problemberichte", data?.problem_reports],
  ];

  return (
    <div data-testid="admin-reporting">
      <h1 className="text-3xl">Reporting</h1>
      <label className="mt-3 inline-flex items-center gap-2 text-sm">
        <input type="checkbox" checked={excludeTest} onChange={(e) => setExcludeTest(e.target.checked)} data-testid="exclude-test" />
        Testdaten ausschließen
      </label>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map(([label, value]) => (
          <div key={label} className="rounded-2xl border bg-white p-5">
            <p className="eyebrow">{label}</p>
            <p className="mt-2 text-3xl">{value ?? "–"}</p>
          </div>
        ))}
      </div>
      <h2 className="mt-10 text-2xl">Beliebte Wege</h2>
      <div className="mt-3 overflow-hidden rounded-2xl border bg-white">
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-[var(--brand-soft)] text-left text-xs uppercase"><th className="px-4 py-3">Weg</th><th className="px-4 py-3">gestartet</th><th className="px-4 py-3">abgeschlossen</th></tr></thead>
          <tbody>
            {(data?.popular_walks || []).map((walk) => (
              <tr key={walk.walk_id} className="border-b last:border-0">
                <td className="px-4 py-3">{walk.title}</td>
                <td className="px-4 py-3">{walk.started}</td>
                <td className="px-4 py-3">{walk.completed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
